import uuid from 'uuid/v4';

import { WELLNESS_MENU } from '../constants/content';

let mapItem;

export const normalizeMenus = response => ({
  ...response,
  wellnessMenuUrl: response.objetivoBienestarUrl,
  menus: response.dailyMenus.reduce((map, menu) => {
    mapItem = map;

    mapItem[menu.menuDate] = {
      ...menu,
      id: uuid(),
      menuWellness: menu.objetivoBienestar,
      dishesCategories: menu.objetivoBienestar
        ? menu.dishesCategories.concat({
            id: WELLNESS_MENU.id,
            title: WELLNESS_MENU.title,
            dishesSubcategories: menu.objetivoBienestar
          })
        : menu.dishesCategories
    };

    return mapItem;
  }, {})
});

export const normalizeMenu = response => ({
  ...response,
  dishesCategories: response.objetivoBienestar
    ? response.dishesCategories.concat({
        id: WELLNESS_MENU.id,
        title: WELLNESS_MENU.title,
        dishesSubcategories: response.objetivoBienestar
      })
    : response.dishesCategories,
  menuWellness: response.objetivoBienestar
});

export const normalizeHeader = response =>
  Object.entries(response).map(([key, value], i) => ({
    categoryName: key,
    id: i + 1,
    categories: value.map(({ title, page, url }) => ({
      title,
      page,
      url
    }))
  }));
